{
  "auth": {
    "agree": "Мен келісемін:",
    "createAccount": "Аккаунт ашу",
    "createNewAccount": "Жаңа аккаунт ашу",
    "email": "Электрондық пошта",
    "login": "Кіру",
    "password": "Құпия сөз",
    "recover_password": "Құпия сөзді қалпына келтіру",
    "sign_up": "Тіркелу",
    "keep_logged_in": "Жүйеде қалу",
    "termsOfUse": "Пайдалану шарттарымен.",
    "reset_password": "Құпия сөзді қайта орнату"
  },
  "404": {
    "title": "Бұл бет балық аулауға кетті.",
    "text": "Егер бұл қате деп ойласаңыз, бізге хабарласыңыз: ",
    "back_button": "Басқару панеліне қайту"
  },
  "typography": {
    "primary": "Негізгі мәтін стильдері",
    "secondary": "Қосымша мәтін стильдері"
  },
  "dashboard": {
    "versions": "Нұсқалар",
    "setupRemoteConnections": "Қашықтан қосылуды баптау",
    "currentVisitors": "Қазіргі келушілер",
    "navigationLayout": "Навигация макеті",
    "topBarButton": "Жоғарғы панель",
    "sideBarButton": "Бүйірлік панель"
  },
  "language": {
    "brazilian_portuguese": "Португал тілі",
    "english": "Ағылшын тілі",
    "spanish": "Испан тілі",
    "simplified_chinese": "Қытай тілі (жеңілдетілген)",
    "persian": "Парсы тілі"
  },
  "menu": {
    "auth": "Авторизация",
    "buttons": "Түймелер",
    "timelines": "Уақыт шкалалары",
    "dashboard": "Басқару панелі",
    "orders": "Тапсырыстар",
    "services": "Қызметтер",
    "loyalty": "Лояльділік бағдарламасы",
    "clients": "Клиенттер",
    "feedbacks": "Пікірлер",
    "billing": "Биллинг",
    "login": "Кіру",
    "preferences": "Аккаунт баптаулары",
    "payments": "Төлемдер",
    "settings": "Сайт баптаулары",
    "pricing-plans": "Тарифтік жоспарлар",
    "payment-methods": "Төлем әдістері",
    "signup": "Тіркелу",
    "recover-password": "Құпия сөзді қалпына келтіру",
    "recover-password-email": "Қалпына келтіруге арналған Email",
    "404": "404",
    "faq": "Жиі қойылатын сұрақтар",
    "users": "Пайдаланушылар",
    "projects": "Жобалар"
  },
  "messages": {
    "all": "Барлық хабарламалар",
    "new": "{name} пайдаланушысынан жаңа хабарламалар",
    "mark_as_read": "Оқылған деп белгілеу"
  },
  "navbar": {
    "messageUs": "Веб-әзірлеу бойынша сұрақтар:",
    "repository": "GitHub репозиторийі"
  },
  "notifications": {
    "all": "Барлық хабарландырулар",
    "less": "Аз көрсету",
    "mark_as_read": "Оқу",
    "sentMessage": "сізге хабарлама жіберді",
    "uploadedZip": "{type} бар жаңа Zip-файл жүктеді",
    "startedTopic": "жаңа тақырып бастады",
    "empty": "Хабарландырулар жоқ"
  },
  "user": {
    "language": "Тілді өзгерту",
    "logout": "Шығу",
    "profile": "Профиль",
    "settings": "Баптаулар",
    "billing": "Биллинг",
    "faq": "FAQ",
    "helpAndSupport": "Көмек және қолдау",
    "projects": "Жобалар",
    "account": "Аккаунт",
    "explore": "Шолу"
  },
  "treeView": {
    "basic": "Қарапайым",
    "icons": "Иконкалар",
    "selectable": "Таңдалатын",
    "editable": "Өңделетін",
    "advanced": "Кеңейтілген"
  },
  "chat": {
    "title": "Чат",
    "sendButton": "Жіберу"
  },
  "spacingPlayground": {
    "value": "Мән",
    "margin": "Сыртқы шегініс (Margin)",
    "padding": "Ішкі шегініс (Padding)"
  },
  "spacing": {
    "title": "Шегіністер"
  },
  "cards": {
    "cards": "Карточкалар",
    "fixed": "Бекітілген",
    "floating": "Қалқымалы",
    "contentText": "Зебралардың ерекше жолақтары оларды адамдарға ең таныс жануарлардың біріне айналдырады.",
    "contentTextLong": "Зебралардың ерекше жолақтары оларды адамдарға ең таныс жануарлардың біріне айналдырады. Олар саванналар, сирек ормандар, тікенекті бұталар, таулар және жағалаудағы төбелер сияқты әртүрлі мекендеу орындарында кездеседі. Әртүрлі антропогендік факторлар зебралар популяциясына, атап айтқанда терісі үшін аулау және тіршілік ету ортасының бұзылуына қатты әсер етті.",
    "rowHeight": "Жол биіктігі",
    "title": {
      "default": "Әдепкі",
      "withControls": "Басқару элементтерімен",
      "customHeader": "Пайдаланушы тақырыбы",
      "withoutHeader": "Тақырыпсыз",
      "withImage": "Суретпен",
      "withTitleOnImage": "Суреттегі тақырыппен",
      "withCustomTitleOnImage": "Фотодағы арнайы тақырыппен",
      "withStripe": "Жолақпен",
      "withBackground": "Фонмен"
    },
    "button": {
      "main": "Басты",
      "cancel": "Бас тарту",
      "showMore": "Көбірек көрсету",
      "readMore": "Толығырақ оқу"
    },
    "link": {
      "edit": "Өңдеу",
      "setAsDefault": "Әдепкі ретінде орнату",
      "delete": "Жою",
      "traveling": "Саяхат",
      "france": "Франция",
      "review": "Шолу",
      "feedback": "Пікір қалдыру",
      "readFull": "Мақаланы толық оқу",
      "secondaryAction": "Қосымша әрекет",
      "action1": "1-әрекет",
      "action2": "2-әрекет"
    }
  },
  "colors": {
    "themeColors": "Тақырып түстері",
    "extraColors": "Қосымша түстер",
    "gradients": {
      "basic": {
        "title": "Түйме градиенттері"
      },
      "hovered": {
        "title": "Меңзерді апарғандағы градиенттер",
        "text": "Меңзерді апарған кездегі күй үшін түпнұсқа стильге 15% ағарту қолданылады."
      },
      "pressed": {
        "title": "Басқан кездегі градиенттер",
        "text": "Басылған күй үшін түпнұсқа стильге 15% қарайту қолданылады."
      }
    }
  },
  "tabs": {
    "alignment": "Қосымша беттерді теңестіру",
    "overflow": "Қосымша беттердің сыймауы",
    "hidden": "Жасырын слайдері бар қосымша беттер",
    "grow": "Созылмалы қосымша беттер"
  },
  "helpAndSupport": "Көмек және қолдау",
  "aboutVuesticAdmin": "Vuestic Admin туралы",
  "supportAndConsulting": "Қолдау және консалтинг",
  "search": {
    "placeholder": "Іздеу..."
  },
  "buttonSelect": {
    "dark": "Күңгірт",
    "light": "Ашық"
  },
  "vuestic": {
    "search": "Іздеу",
    "noOptions": "Ештеңе табылмады",
    "ok": "ОК",
    "cancel": "Бас тарту",
    "uploadFile": "Файлды жүктеу",
    "undo": "Болдырмау",
    "dropzone": "Жүктеу үшін файлдарды осында сүйреңіз",
    "fileDeleted": "Файл жойылды",
    "closeAlert": "Хабарландыруды жабу",
    "backToTop": "Жоғарыға",
    "toggleDropdown": "Тізімді ашу",
    "carousel": "Карусель",
    "goPreviousSlide": "Алдыңғы слайдқа өту",
    "goNextSlide": "Келесі слайдқа өту",
    "goSlide": "{index} слайдына өту",
    "slideOf": "{length} ішінен {index}-слайд",
    "close": "Жабу",
    "openColorPicker": "Түс таңдауды ашу",
    "colorSelection": "Түс таңдау",
    "colorName": "{color} түсі",
    "decreaseCounter": "Есептегішті азайту",
    "increaseCounter": "Есептегішті көбейту",
    "selectAllRows": "Барлық жолдарды таңдау",
    "sortColumnBy": "Бағанды {name} бойынша сұрыптау",
    "selectRowByIndex": "{index} жолын таңдау",
    "resetDate": "Күнді тастау",
    "nextPeriod": "Келесі кезең",
    "switchView": "Көріністі ауыстыру",
    "previousPeriod": "Алдыңғы кезең",
    "removeFile": "Файлды жою",
    "reset": "Тастау",
    "pagination": "Пагинация",
    "goToTheFirstPage": "Бірінші бетке өту",
    "goToPreviousPage": "Алдыңғы бетке өту",
    "goToSpecificPage": "{page}-бетке өту",
    "goToSpecificPageInput": "Өтетін бет нөмірін енгізіңіз",
    "goNextPage": "Келесі бетке өту",
    "goLastPage": "Соңғы бетке өту",
    "currentRating": "Ағымдағы рейтинг {max} ішінен {value}",
    "voteRating": "Рейтингке дауыс беру {max} ішінен {value}",
    "optionsFilter": "Опциялар сүзгісі",
    "splitPanels": "Бөлінген панельдер",
    "movePaginationLeft": "Пагинацияны солға жылжыту",
    "movePaginationRight": "Пагинацияны оңға жылжыту",
    "resetTime": "Уақытты тастау",
    "closeToast": "Хабарландыруды жабу",
    "selectedOption": "Таңдалған опция",
    "noSelectedOption": "Опция таңдалмаған",
    "breadcrumbs": "Навигациялық жол",
    "counterValue": "Есептегіш мәні",
    "selectedDate": "Таңдалған күн",
    "selectedTime": "Таңдалған уақыт",
    "progressState": "Прогресс күйі",
    "color": "Түс",
    "next": "Келесі",
    "back": "Артқа",
    "finish": "Аяқтау",
    "step": "Қадам",
    "progress": "Прогресс",
    "loading": "Жүктелуде",
    "sliderValue": "Слайдердің ағымдағы мәні: {value}",
    "switch": "Ауыстырып-қосқыш",
    "inputField": "Енгізу өрісі",
    "fileTypeIncorrect": "Файл түрі қате",
    "select": "Опцияны таңдаңыз"
  }
}
